module.exports = __webpack_public_path__ + "static/media/users.3e6047ee.svg";